<template>
    <v-container fluid class="mt-9">
        <v-row class="ml-3">
            <v-col cols="12" class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                    <a class="back-link" @click="eventBackToLeads()">
                        <v-icon class="mr-2">mdi-arrow-left</v-icon>
                        <label>Back to Leads</label>
                    </a>
                    <a v-if="lead.event" class="back-link ml-4" :href="`${app_url}events/${lead.event.id}/manage_event`">
                        <label>Go to Event</label>
                        <v-icon class="ml-2">mdi-arrow-right</v-icon>
                    </a>
                </div>
                <div class="d-flex gap-3">
                    <v-btn color="primary" outlined small @click="openLeadHistoryDialog" class="history-btn">
                        <v-icon small left>mdi-account-clock</v-icon>
                        Lead History
                        <!-- <v-badge
                            v-if="lead_activity_count > 0"
                            color="blue"
                            :content="lead_activity_count"
                            inline
                            class="ml-2"
                        ></v-badge> -->
                    </v-btn>
                    <!-- <v-btn
                        color="purple"
                        outlined
                        small
                        @click="openQuoteHistoryDialog"
                        class="history-btn"
                    >
                        <v-icon small left>mdi-file-document-outline</v-icon>
                        Quote History
                        <v-badge
                            v-if="quote_activity_count > 0"
                            color="purple"
                            :content="quote_activity_count"
                            inline
                            class="ml-2"
                        ></v-badge>
                    </v-btn> -->
                </div>
            </v-col>
        </v-row>
        <v-skeleton-loader v-if="lead.email == null" type="table"></v-skeleton-loader>
        <v-row v-else class="mt-5">
            <v-col cols="5">
                <v-card class="settings-card">
                    <div class="card-section-header px-6 py-4 d-flex align-center justify-space-between">
                        <div>
                            <div class="d-flex align-center">
                                <v-icon class="mr-2" color="white" size="18">mdi-account-edit-outline</v-icon>
                                <span class="card-section-title">Edit Lead</span>
                            </div>
                            <div class="card-section-subtitle">Fill out the required information</div>
                        </div>
                        <v-btn small depressed dark color="rgba(255,255,255,0.2)" @click="eventSaveLeadChanges()">
                            <v-icon small left>mdi-content-save-outline</v-icon>
                            Save Changes
                        </v-btn>
                    </div>
                    <v-card-text class="pa-6">
                        <v-form ref="lead_form_data">
                            <v-row class="lead-form-grid">
                                <v-col cols="12">
                                    <label class="form-label">Advisor <span class="required-field">*</span></label>
                                    <v-autocomplete v-model="lead.advisor_id" outlined dense
                                        placeholder="Select Advisor" item-text="name" item-value="id"
                                        :items="getAdvisors" required
                                        :rules="[v => !!v || 'You are required to select an Advisor for this lead.']"></v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">First Name <span class="required-field">*</span></label>
                                    <v-text-field v-model="lead.first_name" outlined dense
                                        placeholder="Enter First Name" type="text" required :rules="[
                                            v => !!v || 'You are required to enter the first name of the organizer for this lead.'
                                        ]"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Last Name</label>
                                    <v-text-field v-model="lead.last_name" outlined dense
                                        placeholder="Enter Last Name" type="text"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Email <span class="required-field">*</span></label>
                                    <v-text-field v-model="lead.email" outlined dense placeholder="Enter Email"
                                        type="text" required :rules="[
                                            v => !!v || 'You are required to enter the email address of the organizer for this lead.'
                                        ]"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Mobile Number</label>
                                    <v-text-field v-model="lead.phone" outlined dense
                                        placeholder="Enter Mobile Number" type="text"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Event Type <span class="required-field">*</span></label>
                                    <v-select v-model="lead.event_type_id" :items="event_types" outlined dense
                                        item-text="name" item-value="id" placeholder="Select Event Type" required
                                        :rules="[
                                            v => !!v || 'You are required to select an event type for this lead.'
                                        ]">
                                    </v-select>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Stag or Hen Name</label>
                                    <v-text-field v-model="lead.stag_or_hen_name" outlined dense
                                        placeholder="Enter Stag or Hen Name" type="text"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Party Location <span class="required-field">*</span></label>
                                    <v-autocomplete v-model="lead.location_id" :items="getLocation" item-text="name"
                                        item-value="id" outlined dense placeholder="Select Party Location" required
                                        :rules="[
                                            v => !!v || 'You are required to select a party location for this lead.'
                                        ]"></v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Party Date <span class="required-field">*</span></label>
                                    <v-menu ref="menu" v-model="party_date.menu" :close-on-content-click="false"
                                        :return-value.sync="party_date.date" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="party_date.formatted_date" outlined dense
                                                placeholder="Select a Party Date to start." type="text"
                                                v-bind="attrs" v-on="on" required :rules="[
                                                    v => !!v || 'You are required to select a party date for this lead.'
                                                ]">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="party_date.date" @change="eventSave"
                                            :events="addPartyActivities" event-color="green"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Nights <span class="required-field">*</span></label>
                                    <v-text-field v-model="lead.duration" outlined dense
                                        placeholder="Enter No. of Nights" type="number" required :rules="[
                                            v => (v !== null && v !== undefined && v !== '') || 'You are required to enter the number of nights for this lead.',
                                            v => (v >= 0) || 'The number of nights cannot be negative for this lead.'
                                        ]"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Group Size <span class="required-field">*</span></label>
                                    <v-text-field v-model="lead.people" outlined dense
                                        placeholder="Enter Group Size" type="number" required :rules="[
                                            v => !!v || 'You are required to enter the number of poeople for this lead.',
                                            v => (v > 0) || 'The number of poeople must be at least one (1) for this lead.'
                                        ]"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Message</label>
                                    <v-textarea v-model="lead.message" outlined dense auto-grow rows="4"
                                        placeholder="Enter Message"></v-textarea>
                                </v-col>
                                <v-col cols="6">
                                    <label class="form-label">Quote Basket Items</label>
                                    <v-textarea v-model="lead.quote_basket_items" outlined dense auto-grow rows="4"
                                        placeholder="Enter Quote Basket Items"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="pa-4">
                        <v-spacer></v-spacer>
                        <v-btn depressed dark color="#3988AA" class="leads-action-btn" @click="eventSaveLeadChanges()">
                            <v-icon small left>mdi-content-save-outline</v-icon>
                            Save Changes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="7">
                <v-card v-if="lead.email != null" class="settings-card">
                    <div class="card-section-header px-6 py-4">
                        <div class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                                <v-icon class="mr-2" color="white" size="18">mdi-file-document-outline</v-icon>
                                <span class="card-section-title">Quotes</span>
                            </div>
                            <div class="d-flex align-center" style="gap:8px;">
                                <v-btn small depressed dark color="rgba(255,255,255,0.2)"
                                    @click="openSentQuotesDialog()">
                                    <v-icon small left>mdi-email-search-outline</v-icon>
                                    Sent Quotes ({{ sent_quotes_count }})
                                </v-btn>
                                <v-btn small depressed dark color="rgba(255,255,255,0.2)" @click="createCustomQuote()">
                                    <v-icon small left>mdi-plus</v-icon>
                                    Custom Quote
                                </v-btn>
                                <v-btn small depressed dark color="rgba(255,255,255,0.2)" @click="createQuickQuote()">
                                    <v-icon small left>mdi-flash-outline</v-icon>
                                    Quick Quote
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <v-card-text>
                        <v-data-table :headers="quote_headers" :items="lead.quotes" :sort-by.sync="sort_by"
                            :sort-desc.sync="sort_desc">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td style="text-align: center;">
                                        <v-icon v-if="hasOrganiserDepositPayment(item)" color="success"
                                            @click.stop="openPaymentDetailsDialog(item)" style="cursor: pointer;"
                                            title="View payment details">
                                            mdi-check-circle
                                        </v-icon>
                                    </td>
                                    <td @click="viewCustomQuote(item)">
                                        <a :href="$router.resolve({ name: 'EditCustomQuote', params: { lead_id: lead.id, quote_id: item.id } }).href"
                                            class="quote-name-link" @click.prevent.stop="viewCustomQuote(item)">{{ item.name }}</a>
                                        <br v-if="item.location">
                                        <v-chip v-if="item.location" x-small color="#AFCFDC" class="mt-1 mb-2">
                                            {{ item.location.name }}
                                        </v-chip>
                                        <v-chip v-if="parentQuoteName(item)" x-small outlined color="#3988AA"
                                            class="mt-1 mb-2" :class="{ 'ml-1': item.location }"
                                            title="Shared services are booked once with the supplier">
                                            Variant of {{ parentQuoteName(item) }}
                                        </v-chip>
                                        <LowProfitChip :check="profit_checks[item.id]"
                                            :currency="get_selected_company.currency" />
                                    </td>
                                    <td @click="viewCustomQuote(item)">
                                        <label v-if="item.total">{{ get_selected_company.currency }}{{
                                            item.total.toFixed(2) }}</label>
                                    </td>
                                    <td @click="viewCustomQuote(item)">
                                        <label v-if="item.groupsize">{{ item.groupsize }}</label>
                                    </td>
                                    <td @click="viewCustomQuote(item)">
                                        <v-chip color="success" v-if="item.date_sent">
                                            {{ $date(item.date_sent).format('DD/MM/YYYY') }}
                                        </v-chip>
                                        <v-chip color="error" v-else>Never</v-chip>
                                    </td>
                                    <td @click="viewCustomQuote(item)">
                                        <label>{{ $date(item.created_at).format('DD/MM/YYYY') }}</label>
                                        <br>
                                        <label style="color:#3886A7;">{{ $date(item.created_at).format('h:m A')
                                            }}</label>
                                    </td>
                                    <td>
                                        <div style="display:flex;align-items:center;">
                                            <v-btn small depressed dark color="#3988AA" class="mr-2 leads-action-btn"
                                                @click="openCreateEventDialog(item)" v-if="!item.is_booked">
                                                <v-icon small left>mdi-bookmark-outline</v-icon>Book
                                            </v-btn>
                                            <v-btn small depressed dark color="#7C7C7C" class="mr-2 leads-action-btn"
                                                @click="unbookQuote(item)" v-else>
                                                <v-icon small left>mdi-bookmark-remove-outline</v-icon>Unbook
                                            </v-btn>
                                            <v-menu right bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn small dense icon v-bind="attrs" v-on="on">
                                                        <v-icon color="black">mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item style="cursor:pointer;" @click="viewCustomQuote(item)">
                                                        <v-list-item-title>
                                                            <v-icon>mdi-magnify</v-icon>View/Update Quote
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item style="cursor:pointer;"
                                                        @click="openPreviewQuoteDialog(item)">
                                                        <v-list-item-title>
                                                            <v-icon>mdi-navigation-variant-outline</v-icon>Send Quote
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item style="cursor:pointer;" @click="copyQuote(item)">
                                                        <v-list-item-title>
                                                            <v-icon>mdi-content-copy</v-icon>Copy Quote
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item style="cursor:pointer;"
                                                        @click="deleteQuoteDialog(item)">
                                                        <v-list-item-title>
                                                            <v-icon>mdi-delete</v-icon>Delete Quote
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                    </v-card-actions>
                </v-card>
                <LeadNotes v-if="lead.id" :key="'notes-' + ai_refresh_key" class="mt-6" style="margin-left:1rem;" :lead_id="lead.id" />
                <!-- Bottom margin keeps the last card clear of the AI assistant bubble -->
                <SupplierAvailability v-if="lead.id && lead.email != null" :key="'avail-' + ai_refresh_key" class="mt-6" style="margin-left:1rem;margin-bottom:96px;" :lead="lead"
                    :location-name="leadLocationName" />
            </v-col>
        </v-row>
        <CopyQuoteDialog v-model="copy_quote_dialog" :quote_id="copy_quote_id" :lead_id="lead.id"
            :event_id="lead.event ? lead.event.id : null" @copied="onQuoteCopied" />
        <ConfirmDeleteQuote :delete_quote_dialog="delete_quote_dialog" :quote_id="delete_quote_id"
            @closeDeleteQuoteDialog="closeDeleteQuoteDialog()" @deleteQuote="deleteQuote()"></ConfirmDeleteQuote>
        <CreateNewEvent v-if="create_event_dialog" :create_event_dialog="create_event_dialog" :quote="quote_for_event" :lead="lead"
            @closeCreateEventDialog="closeCreateEventDialog()" @createEvent="createEvent" @bookQuote="bookQuote">
        </CreateNewEvent>
        <ViewSentQuotes :sent_quotes_dialog="sent_quotes_dialog" :lead_id="lead.id"
            @closeSentQuotesDialog="closeSentQuotesDialog()">
        </ViewSentQuotes>
        <PreviewQuoteEmail :preview_dialog="preview_quote_dialog" :quote="quote_for_preview" :lead="lead"
            :company="get_selected_company" @closePreviewDialog="closePreviewQuoteDialog()" @sendQuote="sendQuoteEmail"
            @sendQuoteViaSms="sendQuoteViaSms" @sendQuoteViaWhatsApp="sendQuoteViaWhatsApp">
        </PreviewQuoteEmail>
        <v-dialog v-model="payment_details_dialog" max-width="600px">
            <v-card>
                <v-card-title class="text-h5 primary white--text">
                    <v-icon left color="white">mdi-cash-check</v-icon>
                    Payment Details
                </v-card-title>
                <v-card-text class="pt-4" v-if="selected_payment">
                    <v-row>
                        <v-col cols="12">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Quote Name</v-list-item-subtitle>
                                        <v-list-item-title class="text-h6">{{ selected_payment.quote_name
                                        }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Total Paid Amount</v-list-item-subtitle>
                                        <v-list-item-title class="text-h6">{{ get_selected_company.currency }}{{
                                            selected_payment.total_paid_amount.toFixed(2) }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Payment Date</v-list-item-subtitle>
                                        <v-list-item-title>{{ $date(selected_payment.payment_date).format('DD/MM/YYYY')
                                        }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Payment Gateway</v-list-item-subtitle>
                                        <v-list-item-title>{{ selected_payment.payment_gateway }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-if="selected_payment.reference_code">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Reference Code</v-list-item-subtitle>
                                        <v-list-item-title>{{ selected_payment.reference_code }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="payment_details_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <UserActivityDialog v-model="activity_dialog" :title="activity_dialog_title"
            :subtitle="activity_dialog_subtitle" :activities="displayed_activities" :filter-type="activity_filter_type"
            :total-items="displayed_total_activities" :loading="activities_loading" @close="closeActivityDialog"
            @options-changed="handleActivityOptionsChanged">
        </UserActivityDialog>
        <SupplierChangesPrompt :changes="supplier_changes" @close="supplier_changes = null" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ConfirmDeleteQuote from './components/ConfirmDeleteQuote.vue'
import CopyQuoteDialog from '../quotes/components/CopyQuoteDialog.vue'
import CreateNewEvent from '../events/components/CreateNewEvent.vue'
import ViewSentQuotes from './components/ViewSentQuotes.vue'
import PreviewQuoteEmail from './components/PreviewQuoteEmail.vue'
import UserActivityDialog from '../useractivity/UserActivityDialog.vue'
import LowProfitChip from '../quotes/components/LowProfitChip.vue'
import { fetchProfitChecks } from '../../utils/lowProfit'
import SupplierChangesPrompt from '../events/components/SupplierChangesPrompt.vue'
import SupplierAvailability from '../suppliers/availability/SupplierAvailability.vue'
import LeadNotes from './components/LeadNotes.vue'
import { lookups, loadLookups } from '@/common/companyLookups'

export default {
    components: {
        ConfirmDeleteQuote, CreateNewEvent, ViewSentQuotes, PreviewQuoteEmail, UserActivityDialog, CopyQuoteDialog, LowProfitChip,
        SupplierChangesPrompt, SupplierAvailability, LeadNotes
    },
    data: () => ({
        // Bumped by aiRefresh() so the cards below reload
        ai_refresh_key: 0,
        // From the API after a date change or quote delete: booked suppliers to offer an email.
        supplier_changes: null,
        quote_headers: [
            { text: 'Paid', value: 'paid', width: '60px', sortable: false, align: 'center' },
            { text: 'Quote Name', value: 'name' },
            { text: 'Total', value: 'total' },
            { text: 'Groupsize', value: 'groupsize' },
            { text: 'Date Sent', value: 'date_sent' },
            { text: 'Created', value: 'created_at', width: '120px' },
            { text: 'Action', value: 'action', width: '100', align: 'center' },
        ],
        lead: {
            id: null,
            advisor_id: 0,
            duration: 1,
            event_type_id: null,
            start_date: null,
            location_id: null,
            first_name: null,
            last_name: null,
            phone: null,
            email: null,
            password: null,
            people: 1,
            company_id: null,
            stag_or_hen_name: null,
            quote_basket_items: null,
        },
        party_date: {
            menu: false,
            date: new Date().toISOString().split("T")[0],
            formatted_date: new Date().toLocaleDateString(),
        },
        show_password: false,
        show_confirm_password: false,
        confirm_password: null,
        classes: {
        },
        sort_by: 'id',
        sort_desc: true,
        delete_quote_id: null,
        delete_quote_dialog: false,
        copy_quote_dialog: false,
        copy_quote_id: null,
        create_event_dialog: false,
        quote_for_event: null,
        sent_quotes_dialog: false,
        sent_quotes_count: 0,
        preview_quote_dialog: false,
        quote_for_preview: null,
        // Activity tracking
        displayed_activities: [],
        activity_dialog: false,
        activity_dialog_title: '',
        activity_dialog_subtitle: '',
        activity_filter_type: 'all',
        // Payment details
        payment_details_dialog: false,
        selected_payment: null,
        lead_activity_count: 0,
        quote_activity_count: 0,
        total_activities: 0,
        displayed_total_activities: 0,
        activities_loading: false,
        activity_options: {
            page: 1,
            itemsPerPage: 10
        },
        is_fetching_activities: false,
        profit_checks: {},
    }),
    watch: {
        // Re-check low profit whenever the lead's quotes are reloaded or change.
        profit_check_key: {
            async handler() {
                this.profit_checks = await fetchProfitChecks(this.$axios, this.lead.quotes)
            },
        },
    },
    computed: {
        app_url() {
            return process.env.VUE_APP_URL
        },
        leadLocationName() {
            const location = (this.getLocation || []).find(l => l.id === this.lead.location_id)
            return location ? location.name : 'this location'
        },
        profit_check_key() {
            return (this.lead.quotes || []).map((quote) => `${quote.id}:${quote.total}:${quote.updated_at}`).join(',')
        },
        getAdvisors() {
            return lookups.advisors
        },
        getLocation() {
            return lookups.locations
        },
        event_types() {
            return lookups.event_types
        },
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
        addPartyActivities() {
            let number_of_days = 0;
            return [...Array(parseInt(this.lead.duration))].map(() => {
                const event_date = new Date(this.party_date.date)
                number_of_days = number_of_days + 1
                event_date.setDate(event_date.getDate() + number_of_days)
                return event_date.toISOString().substr(0, 10)
            })
        }
    },
    async mounted() {
        this.setPageName("Edit Lead")

        this.lead.id = this.$route.params.id
        const response = await this.$axios.get(`admin/leads/get_lead/${this.lead.id}`)
        const lead_data = response.data?.data
        this.lead = lead_data
        document.title = `Lead - ${this.lead.first_name} ${this.lead.last_name} - GGB`
        this.party_date.date = new Date(this.lead.start_date).toISOString().split("T")[0]
        this.party_date.formatted_date = new Date(this.lead.start_date).toLocaleDateString()
        this.confirm_password = lead_data.password

        loadLookups('advisors', 'locations', 'event_types')
        this.fetchSentQuotesCount()
        this.fetchLeadActivities()
    },
    methods: {
        ...mapActions({
            setPageName: 'pageNameStore/setPageNameAction',
        }),
        eventBackToLeads() {
            this.$router.push({ name: 'Leads' })
        },
        async fetchLead() {
            const response = await this.$axios.get(`admin/leads/get_lead/${this.lead.id}`)
            this.lead = response.data?.data
        },
        // Called by the AI Assistant after it changes data: reload the lead, its quotes and cards in place
        async aiRefresh() {
            await this.fetchLead()
            this.fetchSentQuotesCount()
            this.fetchLeadActivities()
            this.ai_refresh_key++
        },
        eventSave(party_date) {
            this.$refs.menu.save(party_date)
            this.party_date.formatted_date = new Date(party_date).toLocaleDateString()
        },
        async eventSaveLeadChanges() {
            const valid = this.$refs.lead_form_data.validate()
            if (valid) {
                this.lead.start_date = this.party_date.date
                const format_date = new Date(this.lead.start_date).toISOString().split('T')[0]
                const response = await this.$axios.post(`admin/leads/update_lead/${this.lead.id}`, {
                    first_name: this.lead.first_name, last_name: this.lead.last_name, email: this.lead.email,
                    phone: this.lead.phone, people: this.lead.people, duration: this.lead.duration,
                    event_type_id: this.lead.event_type_id, start_date: format_date,
                    location_id: this.lead.location_id, message: this.lead.message,
                    advisor_id: this.lead.advisor_id, company_id: this.lead.company_id, password: this.lead.password,
                    stag_or_hen_name: this.lead.stag_or_hen_name, quote_basket_items: this.lead.quote_basket_items
                })
                const result = response.data
                if (result.response == true) {
                    this.fetchLead()
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                    this.supplier_changes = result.supplier_changes || null
                } else {
                    this.$toast.error(result.message)
                }
            }
        },
        createCustomQuote() {
            this.$router.push({ name: 'CreateCustomQuote', params: { lead_id: this.lead.id } })
        },
        createQuickQuote() {
            this.$router.push({ name: 'CreateQuickQuote', params: { lead_id: this.lead.id } })
        },
        viewCustomQuote(item) {
            this.$router.push({ name: 'EditCustomQuote', params: { lead_id: this.lead.id, quote_id: item.id } })
        },
        // The main package this quote is a variant of. Copies record the main package, but older
        // links can point at another variant, so follow them up (stopping at a deleted quote).
        parentQuoteName(item) {
            const quotes = this.lead.quotes
            let parent = null
            let parentId = item.parent_quote_id
            const seen = new Set([item.id])
            while (parentId && !seen.has(parentId)) {
                seen.add(parentId)
                const next = quotes.find(q => q.id === parentId)
                if (!next) break
                parent = next
                parentId = next.parent_quote_id
            }
            return parent ? parent.name : null
        },
        copyQuote(item) {
            this.copy_quote_id = item.id
            this.copy_quote_dialog = true
        },
        onQuoteCopied(result) {
            this.lead = result.data
        },
        openPreviewQuoteDialog(item) {
            if (item.total == null) {
                this.$toast.error('Please edit this quote and make sure the total price is saved')
                return
            }
            this.quote_for_preview = item
            this.preview_quote_dialog = true
        },
        closePreviewQuoteDialog() {
            this.preview_quote_dialog = false
            this.quote_for_preview = null
        },
        async sendQuoteEmail(options) {
            try {
                let payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.lead,
                    quote: this.quote_for_preview,
                    show_description: options.show_descriptions,
                    show_names: options.show_names,
                }
                const response = await this.$axios.post('admin/quotes/send_email_quote', payload)
                const result = response.data
                if (result.response == true) {
                    this.lead = result.data
                    this.sent_quotes_count++
                    this.fetchLeadActivities()
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                }
                else {
                    this.$toast.error(result.message)
                }
            } catch (error) {
                this.$toast.error('Failed to send quote email')
            } finally {
                this.closePreviewQuoteDialog()
            }
        },
        async sendQuoteViaSms() {
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.lead,
                    quote: this.quote_for_preview,
                }
                const response = await this.$axios.post('admin/quotes/send_sms_quote', payload)
                const result = response.data
                if (result.response == true) {
                    this.lead = result.data
                    this.sent_quotes_count++
                    this.fetchLeadActivities()
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                } else {
                    this.$toast.error(result.message)
                }
            } catch (error) {
                this.$toast.error('Failed to send quote via SMS')
            } finally {
                this.closePreviewQuoteDialog()
            }
        },
        async sendQuoteViaWhatsApp() {
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.lead,
                    quote: this.quote_for_preview,
                }
                const response = await this.$axios.post('admin/quotes/send_whatsapp_quote', payload)
                const result = response.data
                if (result.response == true) {
                    this.lead = result.data
                    this.sent_quotes_count++
                    this.fetchLeadActivities()
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                } else {
                    this.$toast.error(result.message)
                }
            } catch (error) {
                this.$toast.error('Failed to send quote via WhatsApp')
            } finally {
                this.closePreviewQuoteDialog()
            }
        },
        openCreateEventDialog(item) {
            this.create_event_dialog = true
            this.quote_for_event = item
        },
        closeCreateEventDialog() {
            this.create_event_dialog = false
        },
        async createEvent(event_data, quote_data) {
            let payload = {
                company_id: this.get_selected_company.id,
                company: this.get_selected_company,
                lead_id: this.lead.id,
                name: event_data.name,
                deposit_amount: parseFloat(event_data.deposit_amount),
                quote_id: quote_data.id,
            }
            const response = await this.$axios.post('admin/events/create_event', payload)
            const result = response.data
            if (result.response == true) {
                let quote_payload = {
                    event_id: result.data.id,
                    builds: quote_data.builds,
                    groupsize: this.lead.people,
                }
                this.$axios.post('admin/quotes/update_quote_builds', quote_payload)

                this.$toast.success(result.message, { timeout: 2000, icon: true })
                this.fetchLead()
                this.closeCreateEventDialog()
            }
        },
        async bookQuote(quote_data) {
            let payload = {
                company_id: this.get_selected_company.id,
                id: quote_data.id,
                event_id: this.lead.event.id,
                is_booked: 1,
            }
            const response = await this.$axios.post(`admin/quotes/update_quote/${payload.id}`, payload)
            const result = response.data
            if (result.response == true) {
                let quote_payload = {
                    event_id: this.lead.event.id,
                    builds: quote_data.builds,
                    groupsize: this.lead.people,
                }
                this.$axios.post('admin/quotes/update_quote_builds', quote_payload)

                this.$toast.success(result.message, { timeout: 2000, icon: true })
                this.fetchLead()
                this.closeCreateEventDialog()
            }
        },
        async unbookQuote(item) {
            let payload = {
                company_id: this.get_selected_company.id,
                id: item.id,
                event_id: null,
                is_booked: 0,
            }
            const response = await this.$axios.post(`admin/quotes/update_quote/${payload.id}`, payload)
            const result = response.data
            if (result.response == true) {
                this.$toast.success(result.message, { timeout: 2000, icon: true })
                this.fetchLead()
            }
        },
        async fetchSentQuotesCount() {
            try {
                const response = await this.$axios.get(`admin/quotes/get_quote_emails/${this.lead.id}`)
                if (response.data.response) {
                    this.sent_quotes_count = response.data.data.length
                }
            } catch (e) {
                // silent
            }
        },
        openSentQuotesDialog() {
            this.sent_quotes_dialog = true
        },
        closeSentQuotesDialog() {
            this.sent_quotes_dialog = false
            this.fetchSentQuotesCount()
        },
        deleteQuoteDialog(item) {
            this.delete_quote_dialog = true
            this.delete_quote_id = item.id
        },
        closeDeleteQuoteDialog() {
            this.delete_quote_dialog = false
        },
        async deleteQuote() {
            try {
                const response = await this.$axios.delete(`admin/quotes/delete_quote_with_builds/${this.delete_quote_id}/${this.get_selected_company.id}/${this.lead.id}`)
                const result = response.data
                if (result.response == true) {
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                    this.fetchLead()
                    this.closeDeleteQuoteDialog()
                    this.supplier_changes = result.supplier_changes || null
                }
                else {
                    this.$toast.error(result.message)
                }
            } catch (error) {
                // e.g. the API refuses to delete a quote that has payments against it
                this.$toast.error(error.response?.data?.message || 'Failed to delete quote')
            }
        },
        async fetchLeadActivities(filter = 'all') {
            // Prevent duplicate fetches
            if (this.is_fetching_activities) {
                return
            }

            try {
                this.is_fetching_activities = true
                this.activities_loading = true
                const { page, itemsPerPage } = this.activity_options
                const response = await this.$axios.get(`admin/user_activity/get_lead_activities/${this.lead.id}`, {
                    params: {
                        page: page,
                        per_page: itemsPerPage,
                        filter: filter
                    }
                })
                const result = response.data
                if (result.response) {
                    if (filter === 'all') {
                        // Initial load - just get counts
                        this.lead_activity_count = result.meta.lead_count
                        this.quote_activity_count = result.meta.quote_count
                    } else {
                        // Filtered load for dialog
                        this.displayed_activities = result.data
                        this.displayed_total_activities = result.meta.total
                    }
                }
            } catch (error) {
                console.error('Failed to fetch lead activities:', error)
            } finally {
                this.activities_loading = false
                this.is_fetching_activities = false
            }
        },
        async openLeadHistoryDialog() {
            this.activity_dialog_title = 'Lead Activity History'
            this.activity_dialog_subtitle = `View all activity for ${this.lead.first_name} ${this.lead.last_name}`
            this.activity_filter_type = 'lead'
            this.activity_options.page = 1 // Reset to page 1
            await this.fetchLeadActivities('lead')
            this.activity_dialog = true
        },
        async openQuoteHistoryDialog() {
            this.activity_dialog_title = 'Quote Activity History'
            this.activity_dialog_subtitle = 'View all activity for quotes related to this lead'
            this.activity_filter_type = 'quote'
            this.activity_options.page = 1 // Reset to page 1
            await this.fetchLeadActivities('quote')
            this.activity_dialog = true
        },
        closeActivityDialog() {
            this.activity_dialog = false
            // Don't reset filter type here - keep it for potential re-fetches
        },
        handleActivityOptionsChanged(options) {
            this.activity_options = options
            // Re-fetch with the current filter type
            this.fetchLeadActivities(this.activity_filter_type)
        },
        hasOrganiserDepositPayment(quote) {
            return quote.payments && quote.payments.length > 0
        },
        openPaymentDetailsDialog(quote) {
            if (quote.payments && quote.payments.length > 0) {
                const payment = quote.payments[0]
                let reference_code = ''
                try {
                    const payment_collection = JSON.parse(payment.payment_collection)
                    reference_code = payment_collection.reference_code || ''
                } catch (e) {
                    // ignore
                }
                this.selected_payment = {
                    quote_name: quote.name,
                    total_paid_amount: payment.total_paid_amount,
                    payment_date: payment.payment_date,
                    payment_gateway: payment.payment_gateway,
                    reference_code: reference_code
                }
                this.payment_details_dialog = true
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.quote-name-link {
    color: #3988AA;
    text-decoration: underline;
    display: inline-block;
}

.back-link {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 18px !important;
    color: #3988AA;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;

    .v-icon {
        color: #3988AA;
    }

    label {
        cursor: pointer;
    }
}

.settings-card {
    border-radius: 10px !important;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    overflow: hidden;
    margin-left: 1rem;
}

.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.card-section-subtitle {
    font-family: Manrope;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 2px;
}

.form-label {
    font-family: Manrope;
    font-size: 11px;
    font-weight: 700;
    color: #7C7C7C;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    display: block;
    margin-bottom: 4px;
}

.lead-form-grid > .col {
    padding-top: 0;
    padding-bottom: 0;
}

.required-field {
    color: #E53935;
}

.leads-action-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}

.v-chip__content {
    font-family: Manrope;
}

.history-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: none;
    letter-spacing: 0;
}

.gap-3 {
    gap: 12px;
}
</style>